import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../Images/portfolio.jpeg'

const Header2 = () => {
  return (
    <>
    <nav class="navbar navbar-expand-lg">
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarTogglerDemo01" aria-controls="navbarTogglerDemo01" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse font-weight-bold " id="navbarTogglerDemo01">
        <ul class="nav flex-column mb-3 align-items-center justify-content-center p-3" style={{ height: '100vh', backgroundColor: '#191D2B' }}>
          <img src={logo} alt="Abidur" class="img-thumbnail rounded-circle" style={{ height: '150px', width: '150px' }} />
          <h3 className='pt-3'>Abidur Niloy</h3>
          <h6>Front End Developer</h6>
          <div style={{ width: '250px', textAlign: 'center', }}>
            <Link class="nav-item nav-link active align-middle text-white bg-primary my-2 rounded" to="/">Home
            </Link >
            <Link class="nav-item nav-link text-white bg-primary my-2 rounded" to="/about">About
            </Link >
            <Link class="nav-item nav-link text-white bg-primary my-2 rounded" to="/skill">Skill
            </Link >
            <Link class="nav-item nav-link text-white bg-primary my-2 rounded" to="/portfolios">Portfolios
            </Link >
            <Link class="nav-item nav-link text-white bg-primary my-2 rounded" to="/contact">Contact
            </Link >
          </div>
        </ul>
      </div>
      </nav>
    </>
  );
};

export default Header2;